import React from "react";

import { addGateModal } from "../../redux/actions/sidebar/sidebarAction";
import { store } from "../../redux/storeConfig/store";
import { history } from "../../app/AppRouter";

export const StepButton = (props) => {
  const { isEdit } = props;
  return (
    <>
      <div className="action-wrapper blk-padding-y">
        <div className="action-inner-block">
          <div className="action-btn-block">
            <button
              className="btn btn-medium btn-transparent"
              onClick={() => {
                store.dispatch(addGateModal(false));
                // history.push('/gym-panel/gate');
              }}
            >
              Cancel
            </button>
            <button value="Next" className="btn btn-medium">
              {isEdit ? "Save Changes" : "Add Gate"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
